import React, { useState, useEffect } from "react";
import "./TestimonialSlider.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const TestimonialSlider = ({ testimonials = [], backgroundImage }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [cardsPerPage, setCardsPerPage] = useState(4);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setCardsPerPage(1);
      else if (window.innerWidth < 1024) setCardsPerPage(1);
      else if (window.innerWidth < 1140) setCardsPerPage(2);
      else setCardsPerPage(2);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const totalPages = Math.ceil(testimonials.length / cardsPerPage);
  const startIndex = currentPage * cardsPerPage;
  const currentItems = testimonials.slice(startIndex, startIndex + cardsPerPage);

  const goPrev = () => currentPage > 0 && setCurrentPage(currentPage - 1);
  const goNext = () => currentPage < totalPages - 1 && setCurrentPage(currentPage + 1);

  return (
    <div
      className="testimonial-section"
      // style={{
      //   backgroundImage: `url(${backgroundImage})`,
      // }}
    >
      <div className="testimonial-slider" key={currentPage}>
        {currentItems.map((item, index) => (
          <div className="testimonial-card" key={index}>
            <div className="stars">{"★".repeat(item.stars)}</div>
            <h4>{item.title}</h4>
            <p>{item.text}</p>
            <div className="author">
              <img src={item.img} alt={item.author} />
              <div>
                <strong>{item.author}</strong>
                <small>{item.location}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="testimonial-footer">
        <span className="page-indicator">
          {String(currentPage + 1).padStart(2, "0")} of {String(totalPages).padStart(2, "0")}
        </span>
        <div className="controls">
          <button className="arrow-btn" onClick={goPrev} disabled={currentPage === 0}><FaChevronLeft /></button>
          <button className="arrow-btn" onClick={goNext} disabled={currentPage === totalPages - 1}><FaChevronRight /></button>
        </div>
      </div>
    </div>
  );
};

export default TestimonialSlider;
